<template>
    <v-app>
        <v-app-bar app color="#bbbf32" dark>
            <div class="d-flex align-center">
                <a href="https://r42.ca" target="_blank" rel="noopener noreferrer">
                    <v-img
                        alt="r42 Logo"
                        class="shrink mr-6"
                        contain
                        src="/assets/img/logo-r42-white_40x.png"
                        transition="scale-transition"
                        width="30"
                    />
                </a>
                <v-toolbar-title>Static Map Creator</v-toolbar-title>
            </div>

            <v-spacer></v-spacer>
        </v-app-bar>

        <v-main>
            <transition name="fade">
                <router-view />
            </transition>
        </v-main>
    </v-app>
</template>

<script>
export default {
    name: 'App',

    components: {},

    data: () => ({
        //
    }),
};
</script>
